/**
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export let appConfig;
/**
 * Sets application configuration for current application
 * @public
 * @param config - Application configuration data
 */
export function setAppConfig(config) {
    if (['undefined', 'string', 'number', 'boolean', ''].includes(typeof config) || config === null) {
        throw new Error('setAppConfig invalid config type');
    }
    if (appConfig) {
        throw new Error('AppConfig already configured');
    }
    appConfig = Object.freeze({ ...config });
}
/**
 * Gets application configuration for current application
 * @public
 * @returns Application configuration data
 */
export function getAppConfig() {
    if (!appConfig) {
        throw new Error('AppConfig was not configured yet');
    }
    return appConfig;
}
/**
 * Clears the loaded AppConfig data
 * @internal
 * @remarks Should not be exported to the public
 */
export function clearAppConfig() {
    appConfig = undefined;
}
